import React from "react";
import SizingSummary from "./SizingSummary";
import "./report.scss";
import { useAppSelector } from "../../store/hooks/StoreHooks";
import Loader from "../common/loader";

const Reports: React.FC = () => {
  
  return (
    <div
      className="comparison flex flex-col gap-[16px] p-[20px] border-[1px] rounded-[8px] bg-darkcolor-600 border-darkcolor-400 w-full"
      style={{
        background:
          "var(--Dark-Mode-Gradient-Cards, linear-gradient(181deg, #253240 -16.87%, rgba(37, 48, 64, 0.40) 35.14%))",
      }}
    >
      <SizingSummary />
    </div>
  );
};
export default Reports;